import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Checkbox from "components/forms/inputs/checkbox";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faSave } from "components/icon-library";
import ValuePair from "components/valuepair";
import { getPublicUrl } from "lib/url";
import { List } from "models/list";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { adminDoPatchList } from "services/admin/list";
import { fetchAdminList } from "stores/actions/list";
import { useOrganization } from "stores/hooks/organization";
import * as yup from "yup";

interface SharedFormProps {
  list: List;
}

const SharedForm: FunctionComponent<SharedFormProps> = ({ list }) => {
  const organization = useOrganization();

  const schema = yup
    .object({ shared: yup.boolean(), shared_noindex: yup.boolean() })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { shared: list.shared, shared_noindex: list.shared_noindex },
  });

  const sharedUrl = getPublicUrl(
    organization?.tenant || "www",
    `/shared/list/${list.uuid}`,
  );

  const handleSave = async (values: any) => {
    const { shared, shared_noindex } = values;
    await adminDoPatchList(list, { shared, shared_noindex });
    await fetchAdminList(list.uuid);
  };

  const buttons: FormButtonInterface[] = [
    { ...SubmitButton, text: "Tallenna", align: "left", postIcon: faSave },
  ];

  return (
    <Form methods={methods} onSubmit={handleSave}>
      <Grid>
        <Row>
          <Col>
            <ValuePair label="Luettelon julkinen osoite" copy={list.shared}>
              {list.shared ? sharedUrl : "Luetteloa ei jaettu julkisesti"}
            </ValuePair>
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox name="shared" label="Julkinen linkki" />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox name="shared_noindex" label="Piilota hakukoneilta" />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default SharedForm;
